import {
  ACRONYMS as ACRONYMS_LIFE,
  GLOSSARY as GLOSSARY_LIFE,
  FLASHCARDS as FLASHCARDS_LIFE,
  QUESTIONS as QUESTIONS_LIFE
} from './life'

import {
  ACRONYMS as ACRONYMS_PROPERTY,
  GLOSSARY as GLOSSARY_PROPERTY,
  FLASHCARDS as FLASHCARDS_PROPERTY,
  QUESTIONS as QUESTIONS_PROPERTY,
} from './property'

import {
  ACRONYMS as ACRONYMS_HEALTH,
  GLOSSARY as GLOSSARY_HEALTH,
  FLASHCARDS as FLASHCARDS_HEALTH,
  QUESTIONS as QUESTIONS_HEALTH,
} from './health'

export const BUNDLE_ACRONYMS = {
  life: ACRONYMS_LIFE,
  property: ACRONYMS_PROPERTY,
  health: ACRONYMS_HEALTH
}

export const BUNDLE_GLOSSARY = {
  life: GLOSSARY_LIFE,
  property: GLOSSARY_PROPERTY,
  health: GLOSSARY_HEALTH
}

export const BUNDLE_FLASHCARDS = {
  life: FLASHCARDS_LIFE,
  property: FLASHCARDS_PROPERTY,
  health: FLASHCARDS_HEALTH
}

export const BUNDLE_QUESTIONS = {
  life: QUESTIONS_LIFE,
  property: QUESTIONS_PROPERTY,
  health: QUESTIONS_HEALTH
}
